function formOrder () {
    const btns = document.querySelectorAll('.btn-order');

    const orderName = document.querySelector('#order-name');

    const currentOrderUsluga = localStorage.getItem('order-usluga');
    if (orderName && currentOrderUsluga) {
        orderName.value = currentOrderUsluga;
    }

    for (let btn of btns) {
        btn.addEventListener('click', function (e) {
            if(btn.closest('.caring-cleaning__item') !== null) {
                const parent = btn.closest('.caring-cleaning__item');
                const title = parent.querySelector('.caring-cleaning__title').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                localStorage.setItem('order-usluga', title);
            }
            if(btn.querySelector('.additional-service__title') !== null) {
                const title = btn.querySelector('.additional-service__title').textContent;
                localStorage.setItem('order-usluga', title);
            }
            if(btn.closest('.flowers-wreaths__item') !== null) {
                const parent = btn.closest('.flowers-wreaths__item');
                const title = parent.querySelector('.flowers-wreaths__top').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                localStorage.setItem('order-usluga', title);
            }
        });
    };
}

formOrder();
